import React, { Component } from 'react';
import Slider from 'rc-slider';
import styles from '../../search.scss';
import { defaultDistance } from '../../../../utils/constants';

class DistanceFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            distance: this.props.distance || defaultDistance,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.distance !== this.props.distance) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ distance: this.props.distance || defaultDistance });
        }
    }

    render() {
        const { 'data-testid': dataTestId } = this.props;
        const marks = {
            10: '10mi',
            25: '25mi',
            50: '50mi',
            75: '75mi',
            100: '100mi',
            125: '125mi',
        };
        const getValue = (distanceString) => {
            return parseInt(distanceString.split('mi')[0]);
        };

        return (
            <React.Fragment>
                <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.title`}>
                    Distance <span className={styles.utrRange} data-testid={dataTestId && `${dataTestId}.value`}>{this.state.distance}</span>
                </div>
                <div className="range-wrapper distance-slider" data-testid={dataTestId && `${dataTestId}.slider`}>
                    <Slider
                        step={null}
                        marks={marks}
                        defaultValue={50}
                        value={getValue(this.state.distance)}
                        onChange={val => {
                            this.setState({ distance: `${val}mi` });
                        }}
                        min={10}
                        max={125}
                        onAfterChange={this.props.handleDistanceChange}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default DistanceFilter;
